import React, { Component } from 'react';
import {Redirect, Link} from 'react-router-dom';
import request from 'request';
import queryString from 'querystring';

import ScatterPlot from '../components/scatterplot';
import LineBarGraph from '../components/linebargraph';
import DotPlot from '../components/dotplot';

class Report extends Component {
  constructor(props) {
    super(props);
    this.getAverage = this.getAverage.bind(this);
    this.getReportInfo = this.getReportInfo.bind(this);
    this.calculateReport = this.calculateReport.bind(this);
    this.getAverageResponse = this.getAverageResponse.bind(this);
    this.state = {
        delagative: 0,
        authorative: 0,
        partnership: 0,
        q1_sum: 0,
        q2_sum: 0,
        q3_sum: 0,
        q4_sum: 0,
        style: "",
        satisfaction: "",
        quadrants: [],
        summary: "",
        userData: {},
        user_average_sat: [],
        average_q1: [],
        average_q2: [],
        average_q3: [],
        average_q4: [],
        average_sat: [],
        order: [],
        behavior: ""
    }
  }

  componentDidMount() {
    this.getReportInfo();
    this.getAverage();
    this.getAverageResponse();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.userData !== null) {
        if ((prevState.style !== this.state.style && prevState.satisfaction !== this.state.satisfaction && prevState.quadrants !== this.state.quadrants && prevState.summary !== this.state.summary && this.state.order !== prevState.order) || 
        (this.state.style === "" &&  this.state.satisfaction === "" && this.state.quadrants.length === 0 && this.state.summary === "" && this.state.order.length === 0)) {
            this.calculateReport();
        }
    }
  }

  getAverageResponse() {
    const parent = this;
    request("http://ahc-leadership-prd.oit.umn.edu/api/average_response", function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
              average_sat: [
                jsonBody['avg(s1_1)'] + jsonBody['avg(s2_1)'] + jsonBody['avg(s3_1)'] + jsonBody['avg(s4_1)'],
                jsonBody['avg(s1_2)'] + jsonBody['avg(s2_2)'] + jsonBody['avg(s3_2)'] + jsonBody['avg(s4_2)'],
                jsonBody['avg(s1_3)'] + jsonBody['avg(s2_3)'] + jsonBody['avg(s3_3)'] + jsonBody['avg(s4_3)'],
                jsonBody['avg(s1_4)'] + jsonBody['avg(s2_4)'] + jsonBody['avg(s3_4)'] + jsonBody['avg(s4_4)'],
                jsonBody['avg(s1_5)'] + jsonBody['avg(s2_5)'] + jsonBody['avg(s3_5)'] + jsonBody['avg(s4_5)'],
                jsonBody['avg(s1_6)'] + jsonBody['avg(s2_6)'] + jsonBody['avg(s3_6)'] + jsonBody['avg(s4_6)'],
                jsonBody['avg(s1_7)'] + jsonBody['avg(s2_7)'] + jsonBody['avg(s3_7)'] + jsonBody['avg(s4_7)'],
                jsonBody['avg(s1_8)'] + jsonBody['avg(s2_8)'] + jsonBody['avg(s3_8)'] + jsonBody['avg(s4_8)'],
                jsonBody['avg(s1_9)'] + jsonBody['avg(s2_9)'] + jsonBody['avg(s3_9)'] + jsonBody['avg(s4_9)'],
                jsonBody['avg(s1_10)'] + jsonBody['avg(s2_10)'] + jsonBody['avg(s3_10)'] + jsonBody['avg(s4_10)'],
                jsonBody['avg(s1_11)'] + jsonBody['avg(s2_11)'] + jsonBody['avg(s3_11)'] + jsonBody['avg(s4_11)'],
                jsonBody['avg(s1_12)'] + jsonBody['avg(s2_12)'] + jsonBody['avg(s3_12)'] + jsonBody['avg(s4_12)'],
                jsonBody['avg(vision_s1)'] + jsonBody['avg(vision_s2)'] + jsonBody['avg(vision_s3)'] + jsonBody['avg(vision_s4)'],
                jsonBody['avg(satisfied_s1)'] + jsonBody['avg(satisfied_s2)'] + jsonBody['avg(satisfied_s3)'] + jsonBody['avg(satisfied_s4)'],
                jsonBody['avg(empower_s1)'] + jsonBody['avg(empower_s2)'] + jsonBody['avg(empower_s3)'] + jsonBody['avg(empower_s4)'],
              ]
            });
        }
    });  
  }

  getAverage() {
    const parent = this;
    request("http://ahc-leadership-prd.oit.umn.edu/api/average_report", function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
                average_q1: [jsonBody['avg(q1_s1)'], jsonBody['avg(q1_s2)'], jsonBody['avg(q1_s3)'], jsonBody['avg(q1_s4)']], 
                average_q2: [jsonBody['avg(q2_s1)'], jsonBody['avg(q2_s2)'], jsonBody['avg(q2_s3)'], jsonBody['avg(q2_s4)']], 
                average_q3: [jsonBody['avg(q3_s1)'], jsonBody['avg(q3_s2)'], jsonBody['avg(q3_s3)'], jsonBody['avg(q3_s4)']], 
                average_q4: [jsonBody['avg(q4_s1)'], jsonBody['avg(q4_s2)'], jsonBody['avg(q4_s3)'], jsonBody['avg(q4_s4)']]
            });
        }
    });
  }

  getReportInfo() {
    const parent = this;
    const query = queryString.parse(this.props.location.search);

    request("http://ahc-leadership-prd.oit.umn.edu/api/report?id=" + query['?id'], function(error, response, body){
        if (error) {
            return console.log(error);
        }
        if (response.statusCode === 200) {
            let jsonBody = JSON.parse(body);
            parent.setState({
                delagative: jsonBody['vision_s1'] + jsonBody['vision_s2'] + jsonBody['vision_s3'] + jsonBody['vision_s4'],
                authorative: jsonBody['satisfied_s1'] + jsonBody['satisfied_s2'] + jsonBody['satisfied_s3'] + jsonBody['satisfied_s4'],
                partnership: jsonBody['empower_s1'] + jsonBody['empower_s2'] + jsonBody['empower_s3'] + jsonBody['empower_s4'],
                q1_sum: jsonBody['q1_s1'] + jsonBody['q1_s2'] + jsonBody['q1_s3'] +jsonBody['q1_s4'],
                q2_sum: jsonBody['q2_s1'] + jsonBody['q2_s2'] + jsonBody['q2_s3'] +jsonBody['q2_s4'],
                q3_sum: jsonBody['q3_s1'] + jsonBody['q3_s2'] + jsonBody['q3_s3'] +jsonBody['q3_s4'],
                q4_sum: jsonBody['q4_s1'] + jsonBody['q4_s2'] + jsonBody['q4_s3'] +jsonBody['q4_s4'],
                user_average_sat: [
                    jsonBody['s1_1'] + jsonBody['s2_1'] + jsonBody['s3_1'] + jsonBody['s4_1'],
                    jsonBody['s1_2'] + jsonBody['s2_2'] + jsonBody['s3_2'] + jsonBody['s4_2'],
                    jsonBody['s1_3'] + jsonBody['s2_3'] + jsonBody['s3_3'] + jsonBody['s4_3'],
                    jsonBody['s1_4'] + jsonBody['s2_4'] + jsonBody['s3_4'] + jsonBody['s4_4'],
                    jsonBody['s1_5'] + jsonBody['s2_5'] + jsonBody['s3_5'] + jsonBody['s4_5'],
                    jsonBody['s1_6'] + jsonBody['s2_6'] + jsonBody['s3_6'] + jsonBody['s4_6'],
                    jsonBody['s1_7'] + jsonBody['s2_7'] + jsonBody['s3_7'] + jsonBody['s4_7'],
                    jsonBody['s1_8'] + jsonBody['s2_8'] + jsonBody['s3_8'] + jsonBody['s4_8'],
                    jsonBody['s1_9'] + jsonBody['s2_9'] + jsonBody['s3_9'] + jsonBody['s4_9'],
                    jsonBody['s1_10'] + jsonBody['s2_10'] + jsonBody['s3_10'] + jsonBody['s4_10'],
                    jsonBody['s1_11'] + jsonBody['s2_11'] + jsonBody['s3_11'] + jsonBody['s4_11'],
                    jsonBody['s1_12'] + jsonBody['s2_12'] + jsonBody['s3_12'] + jsonBody['s4_12'],
                    jsonBody['vision_s1'] + jsonBody['vision_s2'] + jsonBody['vision_s3'] + jsonBody['vision_s4'],
                    jsonBody['satisfied_s1'] + jsonBody['satisfied_s2'] + jsonBody['satisfied_s3'] + jsonBody['satisfied_s4'],
                    jsonBody['empower_s1'] + jsonBody['empower_s2'] + jsonBody['empower_s3'] + jsonBody['empower_s4']
                  ],
                userData: jsonBody
            });
        }
    });
  }

  calculateReport() {
    const leadership = [
        this.state.delagative, 
        this.state.authorative, 
        this.state.partnership
    ];
    const satisfied = [
        this.state.userData['satisfied_s1'],
        this.state.userData['satisfied_s2'],
        this.state.userData['satisfied_s3'],
        this.state.userData['satisfied_s4']
    ];

    const sum = [
        this.state.q1_sum,
        this.state.q2_sum,
        this.state.q3_sum,
        this.state.q4_sum
    ];

    const leadership_behavior = [
        this.state.userData.s1_1 + this.state.userData.s2_1 + this.state.userData.s3_1 + this.state.userData.s4_1,
        this.state.userData.s1_2 + this.state.userData.s2_2 + this.state.userData.s3_2 + this.state.userData.s4_2,
        this.state.userData.s1_3 + this.state.userData.s2_3 + this.state.userData.s3_3 + this.state.userData.s4_3,
        this.state.userData.s1_4 + this.state.userData.s2_4 + this.state.userData.s3_4 + this.state.userData.s4_4,
        this.state.userData.s1_5 + this.state.userData.s2_5 + this.state.userData.s3_5 + this.state.userData.s4_5,
        this.state.userData.s1_6 + this.state.userData.s2_6 + this.state.userData.s3_6 + this.state.userData.s4_6,
        this.state.userData.s1_7 + this.state.userData.s2_7 + this.state.userData.s3_7 + this.state.userData.s4_7,
        this.state.userData.s1_8 + this.state.userData.s2_8 + this.state.userData.s3_8 + this.state.userData.s4_8,
        this.state.userData.s1_9 + this.state.userData.s2_9 + this.state.userData.s3_9 + this.state.userData.s4_9,
        this.state.userData.s1_10 + this.state.userData.s2_10 + this.state.userData.s3_10 + this.state.userData.s4_10,
        this.state.userData.s1_11 + this.state.userData.s2_11 + this.state.userData.s3_11 + this.state.userData.s4_11,
        this.state.userData.s1_12 + this.state.userData.s2_12 + this.state.userData.s3_12 + this.state.userData.s4_12
    ];

    const style = this.getStyle(leadership);
    const satisfaction = this.getSatisfaction(satisfied);
    const summary = this.getSummary(sum);
    const results = this.getQuadrantResults(sum);
    const order = this.getOrder(sum);
    const behavior = this.getBehavior(leadership_behavior);
    this.setState({
        style: style,
        satisfaction: satisfaction,
        summary: summary,
        quadrants: results,
        order: order,
        behavior: behavior
    })
  }

  getStyle(leadership) {
    let paragraph = "";
    let leadershipMap = {
        0: 'delagative',
        1: 'authoritative',
        2: 'partnership'
    }
    let leadershipMax = Math.max(...leadership);
    let numberMax = [];
    let isZero = [];
    let greaterThanEight = 0;
    leadership.forEach(function(e,i){
        if (e === leadershipMax) {
            numberMax.push(i);
        }
        if (e > 8) {
            greaterThanEight++;
        } else if (e === 0) {
            isZero.push(i);
        } 
    });

    switch (numberMax.length) {
        case 1:
            paragraph += "You are most likely to use a " + leadershipMap[numberMax[0]] + " leadership style.";
            if (greaterThanEight > 1) {
                paragraph += " Your leadership profile is varied, and your styles apply widely across multiple nursing informatics leadership scenarios.";
            }
            break;
        case 2:
            paragraph += "You are most likely to use a " + leadershipMap[numberMax[0]] + " or" + leadershipMap[numberMax[1]] + " leadership style.";
            if (greaterThanEight > 1) {
                paragraph += " Your leadership profile is varied, and your styles apply widely across multiple nursing informatics leadership scenarios.";
            }
            break;
        case 3:
            if (greaterThanEight > 1) {
                paragraph += "Your leadership profile is varied, and your styles apply widely across multiple nursing informatics leadership scenarios.";
            }
            break;
        default:
            break;
    }

    switch (isZero.length) {
        case 0: 
            break;
        case 1:
            paragraph += " You never use " + leadershipMap[isZero[0]] + ".";
            break;
        case 2:
            paragraph += " You never use " + leadershipMap[isZero[0]] + " or " + leadershipMap[isZero[1]] + ".";
            break;
        case 3:
            paragraph += " You never use " + leadershipMap[isZero[0]] + " or " + leadershipMap[isZero[1]] + " or " + leadershipMap[isZero[2]] + ".";
            break;
        default:
            break;
    }

    return paragraph;
  }

  getSatisfaction(satisfied) {
    let paragraph = "";
    let satisficationMap = {
        0: 'creativity and futuristic vision',
        1: 'quick, decisive action',
        2: 'resource management',
        3: 'facilitating collaboration'
    }
    let satisfactionTotal = satisfied[0] + satisfied[1] + satisfied[2] + satisfied[3];
    let satisfactionMax = Math.max(...satisfied);
    let numberMax = [];
    satisfied.forEach(function(e,i){
        if (e === satisfactionMax) {
            numberMax.push(i)
        }
    });

    let overall = "";
    if (satisfactionTotal >= 13) {
        overall += "very satisfied";
    } else if (satisfactionTotal >= 10 && satisfactionTotal <= 12) {
        overall += "usually satisfied";
    } else if (satisfactionTotal <= 9 && satisfactionTotal >= 6) {
        overall += "often satisfied";
    } else if (satisfactionTotal <= 5 && satisfactionTotal >= 3) {
        overall += "rarely satisfied";
    } else if (satisfactionTotal <= 2 && satisfactionTotal >= 0) {
        overall += "not satisfied";
    }

    switch (numberMax.length) {
        case 1:
            paragraph += "You're " + overall + " with leading across all scenarios, and most satisfied when you’re leading in a situation that requires " + satisficationMap[numberMax[0]] + ".";
            break;
        case 2:
            paragraph += "You're " + overall + " with leading across all scenarios, and most satisfied when you’re leading in a situation that requires " + satisficationMap[numberMax[0]] + " or " + satisficationMap[numberMax[1]] + ".";
            break;
        case 3:
            paragraph += "You're " + overall + " with leading across all scenarios, and most satisfied when you’re leading in a situation that requires " + satisficationMap[numberMax[0]] + ", " + satisficationMap[numberMax[1]] + ", or " + satisficationMap[numberMax[2]] + ".";
            break;
        case 4:
            paragraph += "You're " + overall + " with leading across all scenarios, and your satisfaction is independent of the type of situation in which you’re leading.";
            break;
        default:
            break;   
    }

    return paragraph;
 }
  
 getQuadrantResults(quadrantScores) {
    let quadrent_results = [];  
    let scores = [];
    let counter = [];
    const orderMap = {
        0: 'Primarily, ',
        1: 'Similarly, ',
        2: 'Also, ',
        3: 'Finally, '
    }
    for (let i = 0; i < quadrantScores.length; i++) {
        scores.push(quadrantScores[i]);
        counter.push(quadrantScores[i]);
    }

    let order = [];
    // Sort descending order.
    scores.sort(function(a, b){return b-a});
    for (let i = 0; i < quadrantScores.length; i++) {
        let index = counter.indexOf(scores[i])
        order.push(index);
        counter[index] = -1;
    }

    for (let i = 0; i < scores.length; i++) {
        let paragraph = "";
        let index = order[i];
        paragraph += orderMap[i];
        switch (index) {
            case 0:
                if (quadrantScores[index] >= 40) {
                    paragraph += "you're a visionary innovator as you envision, create,and advocate for novel ideas and solutions. This is well suited for achieving new change. You're aligning with a creative orientation in ways that are suited for leading in an informal organization.";
                } else if (quadrantScores[index] < 40 && quadrantScores[index] > 29) {
                    paragraph += "you're able to envision, create,and advocate for novel ideas and solutions when the situation calls for it. When you employ these skills you may achieve transformative change and create innovative outputs.";
                } else {
                    paragraph += "you may be less comfortable leading in a situation that requires you to envision novel ideas and achieve new change. This is especially true in informal organizations that emphasize creativity.";
                }
                break;
            case 1:
                if (quadrantScores[index] >= 40) {
                    paragraph += "you're a producer and competitor as you drive to achieve results quickly, often in high stakes environments.  This is well suited for achieving fast change. You're often recognized as the best, and you're known for fulfilling expectations.";
                } else if (quadrantScores[index] < 40 && quadrantScores[index] > 29) {
                    paragraph += "you're able to compete aggressively and accomplish goals when the situation calls for it.  When you employ these skills with a customer focus, you may produce both profit and effective fast change.";
                } else {
                    paragraph += "you may be less comfortable leading in a competitive, market-driven environment. Your least preferred leadership is in a situation in which you would set and achieve high stakes goals and standards, working to be recognized as the best, and fulfilling expectations quickly for fast change.";
                }
                break;
            case 2:
                if (quadrantScores[index] >= 40) {
                    paragraph += "you're a coordinator and organizer as you obtain and manage resources, connect people and resources, and keep track of progress. This is well suited for achieving incremental change. You can function well in a control orientation and hierarchy culture.";
                } else if (quadrantScores[index] < 40 && quadrantScores[index] > 29) {
                    paragraph += "you're able to coordinate and organize resources and people when the situation calls for it. When you employ these skills you emphasize efficiency, timeliness, consistency, and uniformity toward achieving incremental change.";
                } else {
                    paragraph += "you may be less comfortable leading when expectations are that you manage and track resources, especially in a situation that demands a high level of control within an organization based on hierarchy to achieve incremental changes.";
                }
                break;
            case 3:
                if (quadrantScores[index] >= 40) {
                    paragraph += "you're a facilitator and mentor as you convene and connect people to address issues and create solutions, guide and support others, and foster interpersonal dynamics within groups. This is well suited to achieving long term change. You are most aligned with a collaborative orientation and 'clan' culture.";
                } else if (quadrantScores[index] < 40 && quadrantScores[index] > 29) {
                    paragraph += "you're able to facilitate and mentor individuals and teams when the situation calls for it. When you employ these skills, you emphsize commitment and mutual development, likely to produce long term change in a collaborative environment.";
                } else {
                    paragraph += "you may be less comfortable leading when it is necessary to convene and connect individuals in a collaborative organization, especially related to fostering interpersonal dynamics to achieve long term change.";
                }
                break;
            default:
                break;
        }
        quadrent_results.push(paragraph);    
    }

    return quadrent_results;
 }

 getSummary(scores) {
    let paragraph = "";
    let higherThanThirty = [];
    scores.forEach(function(e,i){
        if (e > 30) {
            higherThanThirty.push(i);
        }
    });
    switch(higherThanThirty.length) {
        case 1:
            switch (higherThanThirty[0]) {
                case 0:
                    paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals your aptitude for leadership in situations demanding vision and innovation who is innovative, visionary and entrepreneurial and can deliver new change, especially in informal organizations that emphasize creativity.";
                    break;
                case 1:
                    paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals your aptitude for leadership in situations demanding rapid action to achieve critical results who is hard driving, competitive and productive and can deliver fast change, especially in competitive, market-driven organizations.";
                    break;
                case 2:
                    paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals your aptitude for leadership in situations demanding management skills who is a coordinator, monitor and organizer and can deliver incremental change, especially in organizations with hierarchical leadership structures.";
                    break;
                case 3:
                    paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals your aptitude for leadership in situations demanding collaboration who is a facilitator, mentor and team builder and can deliver long term change, especially in organizations with a community or ‘clan’ orientation.";
                    break;
                default:
                    break;
            }
            break;
        case 2:
            paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals a focused leader who can deliver change in diverse ways across settings.";
            break;
        case 3:
            paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals a well-rounded leader who can deliver change in diverse ways across settings.";
            break;
        case 4:
            paragraph += "In general, your Minnesota Nursing Informatics Leadership Inventory profile reveals a well-rounded leader who can deliver change in diverse ways across settings.";
            break;
        default:
            break;
    }
    return paragraph;
 }

 getOrder(quadrantScores) {
    let scores = [];
    let order = [];
    let counter = [];

    for (let i = 0; i < quadrantScores.length; i++) {
        scores.push(quadrantScores[i]);
        counter.push(quadrantScores[i]);
    }

    // Sort descending order.
    scores.sort(function(a, b){return b-a});
    for (let i = 0; i < quadrantScores.length; i++) {
        let index = counter.indexOf(scores[i])
        order.push(index);
        counter[index] = -1;
    }

    return order;
 }

 getBehavior(leadership_behavior) {
    const behavior_map = {
        0: "innovator",
        1: "entrepreneur",
        2: "visionary",
        3: "hard driver",
        4: "competitor",
        5: "producer",
        6: "coordinator",
        7: "monitor",
        8: "organizer",
        9: "facilitator",
        10: "mentor",
        11: "team builder"
    };
    let behavior_sorted = [];

    for (let i = 0; i < leadership_behavior.length; i++) {
        behavior_sorted.push([i, leadership_behavior[i]]);
    }
    
    behavior_sorted.sort(function(a,b) {
        return b[1] - a[1];
    });

    let lb1 = behavior_map[behavior_sorted[0][0]];
    let lb2 = behavior_map[behavior_sorted[1][0]];
    let lb3 = behavior_map[behavior_sorted[2][0]];
    let lb4 = behavior_map[behavior_sorted[3][0]];
    let lb5 = behavior_map[behavior_sorted[4][0]];

    return "Your MNILI Profile is specific to your responses across four informatics scenarios. You tend to lead with " + lb1 + ", " + lb2 + ", " + lb3 + ", " + lb4 + ", and " + lb5 + " regardless of the scenario.";
 }

  render() {    
    const quadrantOrder= [
        this.state.average_q1,
        this.state.average_q2,
        this.state.average_q3,
        this.state.average_q4
    ];

    const userOrder = {
        0: [
            this.state.userData.q1_s1,
            this.state.userData.q1_s2,
            this.state.userData.q1_s3,
            this.state.userData.q1_s4,
        ],
        1: [
            this.state.userData.q2_s1,
            this.state.userData.q2_s2,
            this.state.userData.q2_s3,
            this.state.userData.q2_s4
        ], 
        2: [
            this.state.userData.q3_s1,
            this.state.userData.q3_s2,
            this.state.userData.q3_s3,
            this.state.userData.q3_s4
        ],
        3: [
            this.state.userData.q4_s1,
            this.state.userData.q4_s2,
            this.state.userData.q4_s3,
            this.state.userData.q4_s4
        ]
    };

    const quadrantMap = {
        0: 'Creative Culture',
        1: 'Market Culture',
        2: 'Hierarchy Culture',
        3: 'Collaborative Culture'
    };

    const query = queryString.parse(this.props.location.search);
    return (
    query['?id'] === undefined ? <Redirect to='/404'/> : 
      <div className="report">
        <div className='row'>
            <div className='col-1'></div>
            <div className='col-10'>
                <p className='b'> Dear Participant, </p>
                <p> Thank you for completing the Minnesota Nursing Informatics Leadership Inventory. Here are your individual results. </p>
                <div className='row'>
                    <div className='col-12 col-md-3 col-xl-4'></div>
                    <div className='col-12 col-md-6 col-xl-4'>
                        { this.state.userData.length === 0 ? <div></div> : <ScatterPlot width="400" height="400" name="scatterplot" data={this.state.userData}/> }
                    </div>
                    <div className='col-12 col-md-3 col-xl-4'></div>
                </div>
                <p>{this.state.behavior}</p>
                <p>{this.state.style}</p>
                <p>{this.state.satisfaction}</p>
                <div className='row'>
                    <div className='col-md-6 col-xl-8'>
                        <p> {this.state.quadrants[0]} </p>
                    </div>
                    <div className='col-md-6 col-xl-4'>
                        { this.state.order.length === 0 ? <div></div> : <LineBarGraph width='300' height='200' data={quadrantOrder[0]} userData={userOrder[this.state.order[0]]} name='first' group={quadrantMap[this.state.order[0]]}/> }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6  col-xl-8'>
                        <p> {this.state.quadrants[1]} </p>
                    </div>
                    <div className='col-md-6  col-xl-4'>
                    { this.state.order.length === 0 ? <div></div> : <LineBarGraph width='300' height='200' data={quadrantOrder[1]} userData={userOrder[this.state.order[1]]} name='second' group={quadrantMap[this.state.order[1]]}/> }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 col-xl-8'>
                        <p> {this.state.quadrants[2]} </p>
                    </div>
                    <div className='col-md-6 col-xl-4'>
                    { this.state.order.length === 0 ? <div></div> : <LineBarGraph width='300' height='200' data={quadrantOrder[2]} userData={userOrder[this.state.order[2]]} name='third' group={quadrantMap[this.state.order[2]]}/> }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 col-xl-8'>
                        <p> {this.state.quadrants[3]} </p>
                    </div>
                    <div className='col-md-6 col-xl-4'>
                    { this.state.order.length === 0 ? <div></div> : <LineBarGraph width='300' height='200' data={quadrantOrder[3]} userData={userOrder[this.state.order[3]]} name='fourth' group={quadrantMap[this.state.order[3]]}/> }
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-xl-2'></div>
                    <div className='col-12 col-xl-8'>
                        <DotPlot name='dotplot' width='800' height='400' legend="You" data={this.state.average_sat} userData={this.state.user_average_sat}></DotPlot>
                    </div>
                    <div className='col-12  col-xl-2'></div>
                </div>
                <p> {this.state.summary}</p>
                <p className='b'> Thank you for completing the Minnesota Nursing Informatics Leadership Inventory. 
                This assessment and it interpretation are adapted and derived from the competing values framework. 
                Cameron, K. S., & Quinn, R. E. (2011). Diagnosing and changing 
                organizational culture: Based on the competing values framework. John Wiley & Sons.</p>
                <div className="start">
                    <Link to='/dashboard' className='btn btn-lg center red'>Visit our Dashboard</Link> 
                </div>
            </div>
            <div className='col-1'></div>
        </div>
      </div>
    );
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/containers/report.js